<div class="details">
  <!-- Header -->
  <h2 mat-dialog-title class="mat-title">
    <span >{{'Delete_Roles'| translate}}</span>
    <span class="close-dialog" (click)="close()">&#10006;</span>
  </h2>
  <!-- Content -->
  <mat-dialog-content>
        <div class="warning">
          <mat-icon> warning_amber </mat-icon>&nbsp;
          <span>{{ 'ROLES.delete_role_message' | translate }}</span>
        </div>
      <div class="padding-header">
        <div class="header-align">
          <p> {{'ROLES.enter_role_description' | translate}} </p>
        </div>
          <mat-form-field floatLabel="always" appearance="outline" >
            <mat-label class="mat-label">{{ 'COMPANY_USERS.role' | translate }}</mat-label>
            <input
              matInput
              #input
              (keyup)="getValue(input.value)"
              placeholder="{{ 'ROLES.enter_role' | translate }}"
            />
          </mat-form-field>
      </div>
  </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button color="primary"  mat-dialog-close>{{"COMPANY_ADD_USERS.cancel" | translate}}</button>
      <button mat-raised-button color="primary" [disabled]="roleName !== inputValue" [mat-dialog-close]="true">
        {{'COMPANY_DELETE_USERS.delete' | translate}}
      </button>
    </mat-dialog-actions>
</div>
